import { v4 as uuidv4 } from "uuid";
import { getLoggedStatus, getLoggedUserInfo } from "../helpers";
import { Hotel, Product, Room, Search } from "../../@types/IDatalayers";
import { sha256 } from "./sha256";
import { getAffiliationFromHotel } from "./getAffiliation";

const addPaymentInfoEvent = async (
  hotel: Hotel,
  roomsArray: Room[],
  checkin: string,
  checkout: string,
  search: Search
): Promise<void> => {
  const brandName =
    hotel.relationships &&
    hotel.relationships.brand_id &&
    hotel.relationships.brand_id.name;
  const totalRooms = search?.rooms?.length;
  const checkinDate = new Date(search.checkin);
  const checkoutDate = new Date(search.checkout);
  const products: Product[] = [];
  const lengthOfStay = Math.ceil(
    (checkoutDate - checkinDate) / (1000 * 60 * 60 * 24)
  );
  const { email, profileType } = getLoggedUserInfo();
  const totalAdults = search.rooms.reduce((sum, r) => sum + r.adults, 0);
  const totalChildren = search.rooms.reduce((sum, r) => sum + r.children, 0);
  const totalGuests = totalAdults + totalChildren;

  const loggedState = getLoggedStatus();

  const prevRoomDetails = window._roomDataLayerStore;

  let emailHash = "";
  if (email) {
    emailHash = await sha256(email);
  }

  const totalValue = roomsArray.reduce(
    (sum, item) => sum + item?.rate?.subTotalWithFees,
    0
  );

  let firstRate = "";

  roomsArray.forEach(function (r, index) {
    const rate = r.rate;
    if (!firstRate && rate) {
      firstRate = rate;
    }
    r.room &&
      rate &&
      products.push({
        item_id: r.room?.code,
        item_name: r.room?.name,
        index: prevRoomDetails ? prevRoomDetails[index]?.index : "",
        quantity: lengthOfStay,
        coupon: search?.promotionCode || search?.groupCode || "",
        price: +(rate.subTotalWithFees?.toFixed(2) || 0),
        currency: rate.currencyCode,
        item_hotel_brand: brandName,
        item_hotel_name: hotel.name,
        item_hotel_id: hotel.crs_code,
        item_variant: rate.name,
        item_variant_id: rate.rateCode,
        item_list_id: "Product Listing",
        item_category: "Room",
        item_list_name: prevRoomDetails
          ? prevRoomDetails[index]?.item_list_name
          : "",
        start_date: checkin,
        end_date: checkout,
        adults: r.adults || 0,
        children: r.children || 0,
        total_guest: (r.adults || 0) + (r.children || 0),
        ratecount: r.room?.Rates?.length,
      });
  });

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "addpaymentinfo",
    ecommerce: {
      event_id: uuidv4(),
      value: +(totalValue?.toFixed(2) || 0),
      currency: firstRate?.currencyCode,
      coupon: search?.promotionCode || search?.groupCode || "",
      rate_code: firstRate?.rateCode,
      rate_name: firstRate?.name,
      hotel_brand: brandName,
      hotel_name: hotel?.name,
      hotel_id: hotel?.crs_code,
      check_in_date: checkin,
      check_out_date: checkout,
      adults: totalAdults,
      children: totalChildren,
      total_guest: totalGuests,
      length_of_stay: lengthOfStay,
      rooms: totalRooms,
      affiliation: getAffiliationFromHotel(hotel),
      city: hotel.address?.locality,
      list_id: "Product Listing",
      category: "Room",
      list_name:
        window && window._purchaseStartPage ? window._purchaseStartPage : "",
      loggedState: loggedState,
      emailHash: emailHash,
      profileType: profileType,
      items: products,
    },
  });
};

export default addPaymentInfoEvent;
